import React, { useCallback, useEffect, useState } from "react";
import { PageHeader, Tooltip, message } from "antd";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";
import { remove, select } from "../actions/dimensionsAndType";
import { IBehavior, IBehaviorListResponse } from "./types";
import { Utilitaries } from "../../../business";
import { downloadFile } from "../../../components/util";
import { PaginationConfig } from "antd/lib/pagination";
import { ColumnProps, SorterResult } from "antd/lib/table";
import { QmDimensionTable } from "../components/qmTable";
import { WrappedFormBehavior } from "./formBehavioralParameter";

const listName = "tipo_param_comportam";

const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "tipo_comportamento:24:Tipo de Comportamento;designacao:24:Comportamento;descricao:24:Descrição;",
    titulo: "Comportamentos",
};

export function Behavior() {
    const [dataSource, setDataSource] = useState<IBehavior[]>([]);
    const [loadingData, setLoadingData] = useState(true);
    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });

    const [editRow, setEditRow] = useState<IBehavior | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    /** get habilidades from the server */
    const loadData = useCallback(() => {
        setLoadingData(true);
        select({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: IBehaviorListResponse) => {
                const list: IBehavior[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        tipo_comportamento: typeof item.tipo_comportamento === "object" ? "" : item.tipo_comportamento,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                        descricao: typeof item.descricao === "object" ? "" : item.descricao,
                    };
                });

                setDataSource(data);
                setLoadingData(false);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os comportamentos.");
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            loadData();
        }
        setShowModalNew(false);
    }

    function handleEdit(row: IBehavior) {
        setEditRow(row);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            loadData();
        }
        setEditRow(null);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                loadData();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    /** for search results in table */

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof IBehavior, string[]>>,
        sorter: SorterResult<IBehavior>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }
    /****************************** */

    const columns: ColumnProps<IBehavior>[] = [
        {
            title: "Tipo de comportamento",
            dataIndex: "tipo_comportamento",
            width: "30%",
            ...QmDimensionTable.columnsSearch("tipo_comportamento"),
            render: (text) => {
                const value = Utilitaries.isEmpty(text) ? "--" : text;
                return value;
            },
        },
        {
            title: "Comportamento",
            dataIndex: "designacao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("designacao"),
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_tipo_parametros_comportam)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];

    return (
        <>
            <PageHeader title="Lista comportamentos" />
            <QmDimensionTable.list
                rowKey={(record) => record.id_tipo_parametros_comportam}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />

            {showModalNew && <WrappedFormBehavior onClose={handleCloseNew} />}
            {editRow && <WrappedFormBehavior record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
